import React, {useState} from 'react'
import {Modal } from 'react-bootstrap'
import PayLater from './payLater';
import WaitingForPaymant from './waitingForPayment';
import Pay from './pay'


function PaymentModel(props) {
    
  const displayViewScreen = (view)=>{
    if(props.changeView){
      return(
        <Pay 
            submit={props.handlePayNow}
            cancel={props.handlePayLater}
            isVisa={false}
            title={props.title}
            hide={props.hide}
            paymentMethod={props.paymentMethod}
            handlePhoneNumber={props.handlePhoneNumber}
            loader={props.loader}
            paymentDetails = {props.paymentDetails}
          />
      )
    }else if(!props.changeView && !props.payLater){
      return(
        <WaitingForPaymant 
            hide={props.hide}
            phoneNumber={props.phoneNumber}
            paymentDetails = {props.paymentDetails}
            />
      )
    }
    if(props.payLater && !props.changeView){
      return(
        <PayLater 
            hide={props.hide}
        />
      )
    }
  }


    return (
      <> 
        <Modal 
          show={props.show} 
          onHide={props.hide}
          centered
          size="lg">
            {displayViewScreen()}
        </Modal>
      </>
    );
  }
  
export default PaymentModel